<ftr-composable-dropdown [renderMode]="renderType">
  <ftr-composable-dropdown-header>
    <div class="input input--text input--prefix search">
      <input
        #search
        [id]="searchInputId"
        [ngModel]="''"
        (ngModelChange)="filter.next($event)"
        [ngClass]="{ 'input__control--has-value': !!search.value }"
        class="input__control search__prefix"
        type="input"
        [attr.placeholder]="''"
      />

      <span class="input__prefix">
        <ftr-icon icon="Search"></ftr-icon>
      </span>

      <label class="input__label" [for]="searchInputId">{{ searchPlaceholder }}</label>
    </div>
  </ftr-composable-dropdown-header>

  <ftr-composable-dropdown-body>
    <div class="checkbox-list">
      @if (listHeaderTemplate) {
        <div class="checkbox-list__header">
          <ng-container *ngTemplateOutlet="listHeaderTemplate"></ng-container>
        </div>
      }
      @if (viewModel | async; as data) {
        @if ((!listHeaderTemplate && enableSelectAll && !data.hasFilter) || (enableSelectFiltered && data.hasFilter)) {
          <div class="checkbox-list__header">
            <div class="checkbox-list__header-vertical-align">
              @if (enableSelectAll && !data.hasFilter) {
                <ftr-basic-checkbox
                  class="checkbox-list__header-checkbox"
                  [value]="getSelectAllValue(data.filteredItems)"
                  (valueChange)="selectAll(data.filteredItems, $event)"
                  [name]="'Select All'"
                  tabindex="0"
                >
                </ftr-basic-checkbox>
              }
              @if (enableSelectAll && enableSelectFiltered && data.hasFilter) {
                <ftr-basic-checkbox
                  class="checkbox-list__header-checkbox"
                  [value]="getSelectFilteredValue(data.filteredItems)"
                  (valueChange)="selectAllFiltered(data.filteredItems, $event)"
                  [name]="'Select All Filtered ' + pluralNoun + ' (' + data.totalFilterCount + ')'"
                  tabindex="0"
                >
                </ftr-basic-checkbox>
              }
            </div>
          </div>
        }
        <div class="checkbox-list__body">
          @for (item of data.filteredItems; track trackById($index, item)) {
            @if (!item.hidden) {
              <li class="checkbox-list__body-item">
                <ftr-basic-checkbox
                  class="checkbox-list__body-checkbox"
                  [icon]="item.icon ? 'AccountBalance' : undefined"
                  [name]="item.title"
                  [value]="item.selected"
                  [disabled]="!item.selected && selectedCheckboxes >= maxSelectedCheckboxes"
                  (valueChange)="onSelectionChange($event, item)"
                  (keydown.enter)="onSelectionChange(!item.selected, item)"
                >
                </ftr-basic-checkbox>
              </li>
            }
          }
        </div>
      }
    </div>
  </ftr-composable-dropdown-body>
</ftr-composable-dropdown>
